/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const s = ({
  buttonCount: e = 10,
  info: r = !0,
  type: i = "numeric",
  pageSizes: o = void 0,
  previousNext: t = !0,
  responsive: a = void 0,
  navigatable: l = void 0,
  pageSizeValue: n = void 0
}) => ({
  buttonCount: e,
  info: r,
  pageSizes: o === !0 ? [5, 10, 20] : o || void 0,
  previousNext: t,
  responsive: a !== !1,
  navigatable: l !== !1,
  type: i,
  pageSizeValue: n
}), u = (e) => s(e === !0 ? {} : e);
export {
  u as normalize
};
